/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PersonalAssetWithValueDto,
    PersonalAssetWithValueDtoFromJSON,
    PersonalAssetWithValueDtoFromJSONTyped,
    PersonalAssetWithValueDtoToJSON,
} from './PersonalAssetWithValueDto';

/**
 * 
 * @export
 * @interface PersonalAssetListDto
 */
export interface PersonalAssetListDto {
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetListDto
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetListDto
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof PersonalAssetListDto
     */
    offset: number;
    /**
     * 
     * @type {Array<PersonalAssetWithValueDto>}
     * @memberof PersonalAssetListDto
     */
    items: Array<PersonalAssetWithValueDto>;
}

export function PersonalAssetListDtoFromJSON(json: any): PersonalAssetListDto {
    return PersonalAssetListDtoFromJSONTyped(json, false);
}

export function PersonalAssetListDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonalAssetListDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'limit': json['limit'],
        'offset': json['offset'],
        'items': ((json['items'] as Array<any>).map(PersonalAssetWithValueDtoFromJSON)),
    };
}

export function PersonalAssetListDtoToJSON(value?: PersonalAssetListDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'limit': value.limit,
        'offset': value.offset,
        'items': ((value.items as Array<any>).map(PersonalAssetWithValueDtoToJSON)),
    };
}

